var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpendoor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 2H13.0833V14H12V15H13.0833C13.5896 15 14 14.5523 14 14V2C14 1.44772 13.5896 1 13.0833 1H4.91667C4.41041 1 4 1.44772 4 2V2.28077C4 1.6302 4.61139 1.15284 5.24254 1.31063L8.00001 2Z",
    fill: "#91979E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 3.78078L5 2.28078L5 14.2192L11 15.7192L11 3.78078ZM5.24254 1.31063C4.61139 1.15284 4 1.6302 4 2.28077V14.2192C4 14.6781 4.3123 15.0781 4.75746 15.1894L10.7575 16.6894C11.3886 16.8472 12 16.3698 12 15.7192V3.78078C12 3.32191 11.6877 2.92193 11.2425 2.81063L5.24254 1.31063Z",
    fill: "#91979E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.5C10 9.77614 9.77614 10 9.5 10C9.22386 10 9 9.77614 9 9.5C9 9.22386 9.22386 9 9.5 9C9.77614 9 10 9.22386 10 9.5Z",
    fill: "#91979E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpendoor);
export default __webpack_public_path__ + "static/media/opendoor.e1c97d3bb25d7b946b902f5f52759252.svg";
export { ForwardRef as ReactComponent };